import React, { useState } from 'react';

const techStackData = {
  Frontend: [
    { name: 'HTML', icon: '/pictures/HTML_37b7b5d8e7.png' },
    { name: 'CSS', icon: '/pictures/CSS_2b3570e161.png' },
    { name: 'JavaScript', icon: '/pictures/Java_Script_d5f6f2e75c.png' },
    { name: 'Tailwind', icon: '/pictures/Tailwind_0692d04e92.png' },
    { name: 'React', icon: '/pictures/React_683cd50e68.png' },
    { name: 'Vue', icon: '/pictures/Vue_5e9f8cfb8d.png' },
    { name: 'TypeScript', icon: '/pictures/Type_Script_137acf4005.png' },
    { name: 'jQuery', icon: '/pictures/j_Query_6b1dd37e02.png' },
  ],
  Backend: [
    { name: 'Python', icon: '/pictures/React_683cd50e68.png' },
    { name: 'Node.js', icon: '/pictures/Java_Script_d5f6f2e75c.png' },
    { name: 'PHP', icon: '/pictures/Tailwind_0692d04e92.png' },
    { name: 'Java', icon: '/pictures/Vue_5e9f8cfb8d.png' },
    { name: 'Go', icon: '/pictures/Type_Script_137acf4005.png' },
    { name: 'Ruby', icon: '/pictures/j_Query_6b1dd37e02.png' },
  ],
  Database: [
    { name: 'PostgreSQL', icon: '/pictures/Postgre_QL_383c2f9f0e.png' },
    { name: 'MySQL', icon: '/pictures/My_SQL_c87e2924ab.png' },
    { name: 'MongoDB', icon: '/pictures/Mongo_DB_e102740c49.png' },
    { name: 'Redis', icon: '/pictures/React_683cd50e68.png' },
  ],
  Cloud: [
    { name: 'AWS', icon: '/pictures/HTML_37b7b5d8e7.png' },
    { name: 'GCP', icon: '/pictures/CSS_2b3570e161.png' },
    { name: 'Azure', icon: '/pictures/Java_Script_d5f6f2e75c.png' },
  ],
  DevOps: [
    { name: 'Docker', icon: '/pictures/Tailwind_0692d04e92.png' },
    { name: 'Kubernetes', icon: '/pictures/React_683cd50e68.png' },
    { name: 'Jenkins', icon: '/pictures/Vue_5e9f8cfb8d.png' },
    { name: 'GitLab CI', icon: '/pictures/Type_Script_137acf4005.png' },
    { name: 'Terraform', icon: '/pictures/j_Query_6b1dd37e02.png' },
  ],
};

const devNetOpsTechStack = {
  Database: [
    { name: 'PostgreSQL', icon: '/pictures/Postgre_QL_383c2f9f0e.png' },
    { name: 'MySQL', icon: '/pictures/My_SQL_c87e2924ab.png' },
    { name: 'MongoDB', icon: '/pictures/Mongo_DB_e102740c49.png' },
  ],
  Cloud: [
    { name: 'AWS', icon: '/pictures/HTML_37b7b5d8e7.png' },
    { name: 'GCP', icon: '/pictures/CSS_2b3570e161.png' },
    { name: 'Azure', icon: '/pictures/Java_Script_d5f6f2e75c.png' },
  ],
  'Code management': [
    { name: 'Git', icon: '/pictures/React_683cd50e68.png' },
    { name: 'GitLab', icon: '/pictures/Vue_5e9f8cfb8d.png' },
    { name: 'GitHub', icon: '/pictures/Type_Script_137acf4005.png' },
  ],
  Configuration: [
    { name: 'Ansible', icon: '/pictures/Tailwind_0692d04e92.png' },
    { name: 'Terraform', icon: '/pictures/j_Query_6b1dd37e02.png' },
    { name: 'Chef', icon: '/pictures/HTML_37b7b5d8e7.png' },
  ],
  DevOps: [
    { name: 'Docker', icon: '/pictures/Tailwind_0692d04e92.png' },
    { name: 'Kubernetes', icon: '/pictures/React_683cd50e68.png' },
    { name: 'Jenkins', icon: '/pictures/Vue_5e9f8cfb8d.png' },
  ],
};

export default function TechStack({ variant = 'default' }) {
  const data = variant === 'devnetops' ? devNetOpsTechStack : techStackData;
  const tabs = Object.keys(data);
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div>
      {/* Tab buttons */}
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '32px', borderBottom: '1px solid #E5E7EB', paddingBottom: '0' }}>
        {tabs.map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              padding: '10px 20px',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: '500',
              color: activeTab === tab ? '#0099CC' : '#6B7280',
              borderBottom: activeTab === tab ? '2px solid #0099CC' : '2px solid transparent',
              marginBottom: '-1px',
              transition: 'color 0.2s ease',
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Tech icons grid */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px' }}>
        {data[activeTab].map(tech => (
          <div key={tech.name} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', width: '80px' }}>
            <div style={{
              width: '64px', height: '64px',
              borderRadius: '12px',
              border: '1px solid #E5E7EB',
              background: 'white',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              padding: '12px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            }}>
              <img src={tech.icon} alt={tech.name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            </div>
            <span style={{ fontSize: '12px', fontWeight: '500', color: '#374151', textAlign: 'center' }}>{tech.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
